module.exports = [{
  title: '入坑指南',
  pages: [{
    title: '关于 VUX',
    path: '/zh-CN/'
  }, {
    title: '使用 VUX 之前',
    path: '/zh-CN/about/before-using-vux.html'
  }, {
    title: '常见问题',
    path: '/zh-CN/faq/'
  }, {
    title: '使用案例',
    path: '/zh-CN/about/showcase.html'
  }, {
    title: '更新日志',
    path: '/zh-CN/changelog/changelog.html'
  }, {
    title: '贡献者们',
    path: '/zh-CN/about/contributors.html'
  }]
}, {
  title: '安装使用',
  pages: [{
    title: '安装',
    path: '/zh-CN/install/npm.html'
  }, {
    title: '快速开始',
    path: '/zh-CN/install/biolerplate.html'
  }, {
    title: '手动安装配置',
    path: '/zh-CN/install/manual-usage.html'
  }, {
    title: '代码示例',
    path: '/zh-CN/install/usage.html'
  }]
}, {
  title: '定制',
  pages: [{
    title: '国际化',
    path: '/zh-CN/development/i18n.html'
  }, {
    title: '主题',
    path: '/zh-CN/development/theme.html'
  }]
}, {
  title: '开发',
  pages: [{
    title: '路由',
    path: '/zh-CN/development/router.html'
  }, {
    title: '在 Nuxt.js 中使用',
    path: '/zh-CN/development/vux-nuxt-ssr.html'
  }, {
    title: 'TypeScript 支持',
    path: '/zh-CN/development/typescript.html'
  }, {
    title: 'Ajax 请求',
    path: '/zh-CN/development/vue-ajax.html'
  }, {
    title: '点击延迟',
    path: '/zh-CN/development/remove-click-delay-fastclick.html'
  }, {
    title: '使用微信 jssdk',
    path: '/zh-CN/wechat/vue-wechat-jssdk.html'
  }, {
    title: '添加谷歌统计',
    path: '/zh-CN/development/vue-google-analytics.html'
  }, {
    title: '页面切换显示 Loading',
    path: '/zh-CN/development/vue-show-loading.html'
  }, {
    title: '异步加载组件',
    path: '/zh-CN/development/vue-webpack-code-splitting-async.html'
  }, {
    title: '区分测试环境和生产环境',
    path: '/zh-CN/development/vue-webpack-env.html'
  }, {
    title: '全局公共函数',
    path: '/zh-CN/development/vue-global-method.html'
  }, {
    title: 'autoprefix 配置',
    path: '/zh-CN/development/vue-loader-autoprefix.html'
  }, {
    title: '禁用 eslint',
    path: '/zh-CN/development/vue-loader-disable-eslint.html'
  }]
},
{
  title: 'vux-loader',
  pages: [{
    title: 'vux-loader 是什么？',
    path: '/zh-CN/vux-loader/about.html'
  }, {
    title: '安装使用',
    path: '/zh-CN/vux-loader/install.html'
  }, {
    title: '插件列表',
    path: '/zh-CN/vux-loader/plugins.html'
  }]
},
{
  title: '贡献',
  pages: [{
    title: '提交 issue',
    path: '/zh-CN/contribution/issue.html'
  }, {
    title: '提交 pr',
    path: '/zh-CN/contribution/pr.html'
  }, {
    title: '本地开发',
    path: '/zh-CN/contribution/vux-development.html'
  }, {
    title: '感谢',
    path: '/zh-CN/about/thanks.html'
  }]
}]



// WEBPACK FOOTER //
// ./src/summary.js